import React, { Suspense } from 'react';
import { DestyleCSS } from '@card/commonlib';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './rootReducer';
import rootSaga from './rootSaga';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { SettingsScreen } from './features/settings/SettingsScreen';
import I18nProvider from './I18nProvider';
import { ThemeProvider } from '@increasecard/typed-components';
import LayoutBase from './common/components/LayoutCardBase';
import '@increasecard/typed-components/dist/index.css';
import { BaseProvider } from '@increasecard/increase-core';
import config, { environment, productName } from './config';
import OperationsScreen from './features/operations/OperationsScreen';
import { DashboardScreen } from './features/dashboard/DashboardScreen';
import { LoadingIndicator } from './common/components/LoadingIndicator';
import { ChargebacksScreen } from './features/chargebacks/ChargebacksScreen';
import { ReportsScreen } from './features/reports/ReportsScreen';
import { ClearingsScreen } from './features/clearings/ClearingsScreen';
import { RouteChangeTracker } from './common/components/RouteChangeTracker';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware();
const store = createStore(rootReducer, composeEnhancers(applyMiddleware(sagaMiddleware)));
sagaMiddleware.run(rootSaga);

const App = () => {
  return (
    <BaseProvider
      settings={{
        environment,
        productName,
        eventTracking: { enabled: true, mixpanelToken: config.mixpanelToken }
      }}
    >
      <I18nProvider>
        <Router basename="/v2">
          <RouteChangeTracker />
          <Provider store={store}>
            <DestyleCSS />
            <ThemeProvider productName={productName}>
              <LayoutBase>
                <Suspense fallback={<LoadingIndicator />}>
                  <Switch>
                    <Route component={SettingsScreen} path="/settings" />
                    <Route component={OperationsScreen} path="/operations" />
                    <Route component={DashboardScreen} path="/dashboard" />
                    <Route component={ChargebacksScreen} path="/chargebacks" />
                    <Route component={ReportsScreen} path="/reports" />
                    <Route component={ClearingsScreen} path="/clearings" />
                    <Route component={ClearingsScreen} path="/monthlyClearings" />
                    <Route component={ClearingsScreen} path={['/taxes', '/taxations']} />
                    <Redirect exact from="/" to="/settings" />
                  </Switch>
                </Suspense>
              </LayoutBase>
            </ThemeProvider>
          </Provider>
        </Router>
      </I18nProvider>
    </BaseProvider>
  );
};

export default App;
